module.exports = __webpack_public_path__ + "static/media/yahoo.de4eb7dd.svg";